import {PrintStoryDoc, PrintStoryEvent} from '../types'
import {toMillis} from '../time'

const normalizeEvent = (event?: string) => String(event || '').toLowerCase()

export const mapConnectionLogToEvents = (log: PrintStoryDoc): PrintStoryEvent[] => {
  const ts = toMillis(log.createdAtMs) || toMillis(log.createdAt)
  if (!ts) {
    return []
  }

  const event = normalizeEvent(log.event)
  const isDisconnect =
    event.includes('disconnect') || event.includes('client.disconnected') || event === 'disconnected'
  const isConnect =
    (event.includes('connect') && !isDisconnect) ||
    event.includes('client.connected') ||
    event === 'connected'

  if (!isConnect && !isDisconnect) {
    return []
  }

  return [
    {
      ts,
      lane: 'connection',
      laneKey: String(log.deviceId || log.clientId || log.id),
      kind: isDisconnect ? 'connection_disconnected' : 'connection_connected',
      severity: isDisconnect ? 'warning' : 'info',
      deviceId: log.deviceId ? String(log.deviceId) : undefined,
      title: isDisconnect ? 'MQTT disconnected' : 'MQTT connected',
      detail: log.reason || log.event,
      sourceCollection: 'printerConnectionLogs',
      raw: log,
    },
  ]
}

export const mapConnectionLogsToEvents = (logs: PrintStoryDoc[]): PrintStoryEvent[] =>
  logs.flatMap(mapConnectionLogToEvents)
